import React from 'react';

type Props = {
    children: React.ReactNode;
};

const PageContainer: React.FC<Props> = ({ children }) => {
    return children;
};

export default PageContainer;
